import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { LoginComponent } from './login/login.component';
import { ScriptService } from './Services/ScriptLoader/script.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxSummernoteModule } from 'ngx-summernote';
 import {LeafletModule} from '@asymmetrik/ngx-leaflet';
// import {LeafletModule} from 'leaflet-rotatedmarker';
//import { NgxMatDatetimePickerModule, NgxMatTimepickerModule } from '@angular-material-components/datetime-picker';
// import { NgxMatDatetimePickerModule, NgxMatTimepickerModule } from '@angular-material-components/datetime-picker@2.0.4';
import {
  MatInputModule,
  MatButtonModule,
  MatCardModule,
  MatListModule,
  MatToolbarModule,
  MatIconModule,
  MatSidenavModule,
  MatAutocompleteModule,
  MatButtonToggleModule,
  MatCheckboxModule,
  MatChipsModule,
  MatDatepickerModule,
  MatDialogModule,
  MatExpansionModule,
  MatGridListModule,
  MatNativeDateModule,
  MatPaginatorModule,
  MatProgressBarModule,
  MatProgressSpinnerModule,
  MatRadioModule,
  MatRippleModule,
  MatSelectModule,
  MatSliderModule,
  MatSlideToggleModule,
  MatSnackBarModule,
  MatSortModule,
  MatTableModule,
  MatTabsModule,
  MatTooltipModule,
  MatStepperModule,
  MAT_DIALOG_DEFAULT_OPTIONS,
  MAT_DATE_LOCALE,
  MatMenuModule
  


} from '@angular/material';

import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ConfirmDialog } from './Services/Alert/confirm-dialog.component';
import { PIDComponent } from './Project/pid/pid.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { jqxGridComponent } from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxgrid';
//import { jqxDragDropComponent } from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxdragdrop';
import { SearchPidComponent } from './Project/pid/search-pid/search-pid.component';
import { DatePipe } from '@angular/common';
import { PIDStatusComponent } from './Project/pid/pid-status/pid-status.component';
import { PIDApprovalComponent } from './Project/pid/pid-approval/pid-approval.component';

import { CookieService } from 'ngx-cookie-service';

import { PopupComponent } from './Project/popup/popup.component';
import { PIDCostingComponent } from './Project/pid/pidcosting/pidcosting.component';
import { AutoCompleteComponent } from './CustomComponents/auto-complete/auto-complete.component';
import { RightMenuButtonComponent } from './CustomComponents/right-menu-button/right-menu-button.component';

import { jqxPanelComponent } from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxpanel';
import { jqxTabsComponent } from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxtabs';
import { jqxInputComponent } from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxinput';
import { jqxCheckBoxComponent } from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxcheckbox';


import { DecimalDirective } from './Services/Directives/DecimalDirective';
import { DoubleClickDirective } from './Services/Directives/DoubleClickDirectives';
import { NumericDirective } from './Services/Directives/NumericDirective';

import { DragDropModule } from '@angular/cdk/drag-drop';


import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';

import { CMasterComponent } from './Samples/cmaster/cmaster.component';

import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime';

import { AgmCoreModule } from '@agm/core';
// iimport { AgmCoreModule } from '@agm/core/agm-core';

import { CalendarComponent } from './Tools/Calendar/calendar/calendar.component';

import { AddEmployeeComponent } from './employee/add-employee/add-employee.component';
import { EmployeeListComponent } from './employee/employee-list/employee-list.component';
import { DefaultComponent } from './default/default.component';
import { NewbeeComponent } from './website/newbee/newbee.component';
import { SpotlightComponent } from './website/spotlight/spotlight.component';
import { BssCurveComponent } from './website/bss-curve/bss-curve.component';
import { AddcareerComponent } from './career/addcareer/addcareer.component';
import { CareerListComponent } from './career/career-list/career-list.component';
import { CarrierAppliedComponent } from './career/carrier-applied/carrier-applied.component';
import { ChartsModule } from 'ng2-charts';
import { AddAssetComponent } from './asset/add-asset/add-asset.component';
import { EmployeeAssetComponent } from './asset/employee-asset/employee-asset.component';
import { DocuploadComponent } from './website/docupload/docupload.component';
import { PolicyListComponent } from './policies/policy-list/policy-list.component';
import { PolicyComponent } from './policies/policy/policy.component';
import { OnboardingRequestComponent } from './OnboardingRequest/onboarding-request/onboarding-request.component';
import { OnboardingRequestListComponent } from './OnboardingRequest/onboarding-request-list/onboarding-request-list.component';
import { OnboardingComponent } from './Onboarding/onboarding/onboarding.component';
import { OnboardingListComponent } from './Onboarding/onboarding-list/onboarding-list.component';
import { EmployeeTreeComponent } from './employee/employee-tree/employee-tree.component';
@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    HomeComponent,
    ConfirmDialog,
    PIDComponent,
    DashboardComponent,
    jqxGridComponent,
    // jqxDragDropComponent,
    SearchPidComponent,
    PIDStatusComponent,
    PIDApprovalComponent,
    
    PopupComponent,
    PIDCostingComponent,
    AutoCompleteComponent,
    RightMenuButtonComponent,
 
    // jqxPanelComponent,
    // jqxTabsComponent,
    // jqxInputComponent,
    // jqxCheckBoxComponent,

    DecimalDirective,
    DoubleClickDirective,
    NumericDirective,
    CMasterComponent,
    CalendarComponent,
    AddEmployeeComponent,
    EmployeeListComponent,
    DefaultComponent,
    NewbeeComponent,
    SpotlightComponent,
    BssCurveComponent,
    AddcareerComponent,
    CareerListComponent,
    CarrierAppliedComponent,
    AddAssetComponent,
    EmployeeAssetComponent,
    DocuploadComponent,
    PolicyListComponent,
    PolicyComponent,
    OnboardingRequestComponent,
    OnboardingRequestListComponent,
    OnboardingComponent,
    OnboardingListComponent,
    EmployeeTreeComponent
  ],
  imports: [
    // NgxMatTimepickerModule,
    // NgxMatDatetimePickerModule,
    LeafletModule,
    BrowserModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyApuJP3nl9ZZ7vSDKNP0UjXzLU5eXn6apY',
      libraries: ['places']
    }),
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    DragDropModule,
    //BrowserAnimationsModule,
    MatCardModule,
    MatInputModule,
    MatButtonModule,
    MatMenuModule, MatToolbarModule, MatIconModule,
    MatSidenavModule, MatListModule,
    MatAutocompleteModule,
    MatButtonToggleModule,
    MatCheckboxModule,
    MatChipsModule,
    MatDatepickerModule,
    MatDialogModule,
    MatExpansionModule,
    MatGridListModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    MatTooltipModule,
    MatStepperModule,
    BrowserAnimationsModule,
    NgMultiSelectDropDownModule.forRoot(),
    NgxSummernoteModule,
    ChartsModule
   // SatDatepickerModule, SatNativeDateModule,
    //NgMultiSelectDropDownModule.forRoot(),
    //OAuthModule.forRoot()
  ],
  entryComponents: [
    PopupComponent,
  //  ReportPopupComponent
  ],
  providers: [ScriptService,DatePipe, CookieService, { provide: MAT_DATE_LOCALE, useValue: 'en-GB' }],
  bootstrap: [AppComponent]
  
})
export class AppModule { }
